export default "__VITE_ASSET__DYpOK3La__"